import "./Community.scss";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { io } from "socket.io-client";
import { environment } from "../../../environments/environment";
import {
	Link,
	// useLocation,
	useNavigate,
	useSearchParams,
} from "react-router-dom";
import { setThemeColor } from "../../../utils/setThemeColor";
import { useParams } from "react-router-dom";
import axios from "axios";
import FeedPostCard from "../Cards/FeedPost/FeedPostCard";
import CreatePostPopUp from "../../PopUp/CreatePostPopUp/CreatePostPopUp";
import {
	selectIsInvestor,
	selectLoggedInUserId,
} from "../../../Store/features/user/userSlice";

import { selectTheme } from "../../../Store/features/design/designSlice";
import InvestorNavbar from "../../../components/Investor/InvestorNavbar/InvestorNavbar";
import OnboardingSwitch from "../InvestorNavbar/OnboardingSwitch/OnboardingSwitch";
import {
	getAllCommunityPostsAPI,
	getWebinarsByCommunityId,
	getAllCommunityAdminPostsAPI,
	toggleRecieveEmail,
	postUserPost
} from "../../../Service/user";
import InfiniteScroll from "react-infinite-scroll-component";
import SkeletonLoader from "../Feed/Components/SkeletonLoader/SkeletonLoader";
import UpdateCommunityForm from "./UpdateCommunityForm";
import Webinars from "../../Meetings/Webinars/Webinars";
import PeopleTab from "./PeopleTab/PeopleTab";
import Products from "./Products/Products";
import ProductCard from "./Products/ProductCard/ProductCard";
import About from "./About/About";
import { Toaster, toast } from "react-hot-toast";
import { MdMenu, MdMenuOpen } from "react-icons/md";
import { IoFilter, IoSettingsOutline } from "react-icons/io5";
import JoinWhatsAppGroupPopup from "./JoinWhatsAppGroupPopup";
import avatar4 from "../../../Images/avatars/image-4.png";
import WhiteLogo from "../../../Images/investorIcon/logo-white.png";
import DarkLogo from "../../../Images/investorIcon/new-logo.png";
import { FaShareAlt } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import SharePopup from "../../PopUp/SocialSharePopup/SharePopup";
import { useLocation } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import CompletionBanner from './Components/CompletionBanner/CompletionBanner';
import { trackButtonClick } from "../../../Service/userActivityService";

const WhatsAppBanner = ({ onClick, onClose }) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleClick = async () => {
		setIsLoading(true);
		try {
			await onClick();
		} catch (error) {
			console.error("Failed to join WhatsApp group:", error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="whatsapp-banner">
			<div className="banner-content" onClick={handleClick}>
				<div className="banner-text">
					<img
						src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
						alt="WhatsApp"
						className="whatsapp-icon"
					/>
					<div className="banner-message">
						<span className="title">Join our WhatsApp Community</span>
						<span className="subtitle">
							Get instant updates and connect with members
						</span>
					</div>
				</div>
				<button className="join-btn" disabled={isLoading}>
					{isLoading ? (
						<div
							className="spinner-border spinner-border-sm text-light"
							role="status"
						>
							<span className="visually-hidden">Loading...</span>
						</div>
					) : (
						"Join Now"
					)}
				</button>
			</div>
			<button className="close-btn" onClick={onClose} aria-label="Close">
				×
			</button>
		</div>
	);
};

const Community = () => {
	const navigate = useNavigate();
	const [isMobileView, setIsMobileView] = useState(false);
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [showWhatsAppBanner, setShowWhatsAppBanner] = useState(true);
	const location = useLocation();

	// Fetch global state
	const loggedInUserId = useSelector(selectLoggedInUserId);
	const theme = useSelector(selectTheme);
	const loggedInUser = useSelector((state) => state.user.loggedInUser);

	const { communityId } = useParams();
	const [community, setCommunity] = useState(null);
	const [adminPosts, setAdminPosts] = useState([]);
	const [activeTab, setActiveTab] = useState("home");
	const [popupOpen, setPopupOpen] = useState(false);
	const dispatch = useDispatch();
	const [showSettings, setShowSettings] = useState(false);
	const [showWhatsAppPopup, setShowWhatsAppPopup] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [sharePopupOpen, setSharePopupOpen] = useState(false);
	const [communityUrl, setCommunityUrl] = useState("");
	const [webinars, setWebinars] = useState([]);
	const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
	const [receiveEmails, setReceiveEmails] = useState(true);
	const [leaveDialogOpen, setLeaveDialogOpen] = useState(false);
	const [leaveReason, setLeaveReason] = useState('');
	const [isLeaving, setIsLeaving] = useState(false);
	const [isUpdated, setIsUpdated] = useState(false);
	const [repostLoading, setRepostLoading] = useState({
		instant: false,
		withThoughts: false,
	});
	const [respostingPostId, setRepostingPostId] = useState("");

	// Track community actions
	const trackCommunityAction = (buttonName, additionalData = {}) => {
		trackButtonClick(
			"Community", 
			window.location.pathname, 
			buttonName, 
			additionalData
		);
	};

	// fetch community webinars
	useEffect(() => {
		getWebinarsByCommunityId(communityId)
			.then((response) => {
				if (response && response.data) {
					setWebinars(response.data);
				} else {
					console.error("Error fetching webinars:", response);
				}
			})
			.catch((error) => {
				console.error("Error fetching webinars:", error);
			});
	}, [communityId]);

	// New Fetch call
	useEffect(() => {
		document.title = "Community | The Capital Hub";
		window.scrollTo({ top: 0, behavior: "smooth" });
		function handleWindowResize() {
			const isMobile = window.innerWidth <= 820;
			setIsMobileView(isMobile);
		}
		window.addEventListener("resize", handleWindowResize);
		handleWindowResize();

		setThemeColor();

		return () => {
			window.removeEventListener("resize", handleWindowResize);
		};
	}, []);

	useEffect(() => {
		fetchCommunityDetails();
		setIsUpdated(false);
	}, [communityId, isUpdated]);

	useEffect(() => {
		// Check if there's a tab specified in the navigation state
		if (location.state?.activeTab) {
			setActiveTab(location.state.activeTab);
		}
	}, [location.state]);

	useEffect(() => {
		if (community) {
			const userMember = community.members.find(m => m.member._id === loggedInUserId);
			if (userMember) {
				setReceiveEmails(userMember.recieve_email);
			}
		}
	}, [community, loggedInUserId]);

	const fetchCommunityDetails = async () => {
		setIsLoading(true);
		try {
			const token = localStorage.getItem("accessToken");
			const response = await axios.get(
				`${environment.baseUrl}/communities/getCommunityById/${communityId}`
			);
			setCommunity(response.data.data);
		} catch (error) {
			console.error("Error fetching community:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const isAdmin = community?.adminId._id === loggedInUserId;

	// const openCreatePostPopup = () => {
	//   setPopupOpen(true);
	//   dispatch(toggleCreatePostModal());
	// };

	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const [allPosts, setAllPosts] = useState([]);

	// Add this function to fetch community posts
	const fetchMorePosts = () => {
		console.log('Fetching more posts, current page:', page);
		getAllCommunityPostsAPI(communityId, page)
			.then(({ data }) => {
				console.log('Fetched posts data:', data);
				if (data?.length === 0) {
					setHasMore(false);
				} else {
					const communityPosts = data;
					
					if (communityPosts.length === 0) {
						setHasMore(false);
					}
					console.log('Setting posts, current posts:', allPosts);
					console.log('New posts to add:', communityPosts);
					setAllPosts((prevPosts) => [...prevPosts, ...communityPosts]);
					setPage((prevPage) => prevPage + 1);
				}
			})
			.catch((err) => {
				console.error('Error fetching posts:', err);
				setHasMore(false);
			});
	};

	// fetch admin posts 
	const fetchAdminPosts = async () => {
		try {
			const response = await getAllCommunityAdminPostsAPI(communityId, community?.adminId._id);
			const postsData = Array.isArray(response.data)
				? response.data
				: Array.isArray(response.data?.data)
				? response.data.data
				: [];
			setAdminPosts(postsData);
		} catch (error) {
			console.error("Error fetching admin posts:", error);
		}
	};

	// Add this function to handle poll votes
	const handlePollVote = async (postId, optionId) => {
		try {
			const token = localStorage.getItem("accessToken");
			const response = await fetch(`${environment.baseUrl}/api/posts/vote`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({
					postId,
					optionId,
					userId: loggedInUserId,
				}),
			});

			const result = await response.json();
			if (!response.ok) {
				throw new Error(result.message || "Error voting for poll");
			}

			setAllPosts((prevPosts) =>
				prevPosts.map((post) => {
					if (post._id === postId) {
						return {
							...post,
							pollOptions: result.data,
						};
					}
					return post;
				})
			);

			return result.data;
		} catch (error) {
			console.error("Error voting for poll:", error);
			throw error;
		}
	};

	// Add this effect to fetch initial posts
	useEffect(() => {
		if (community?._id) {
			fetchMorePosts();
			fetchAdminPosts();
		}
	}, [community]);

	// Add this function to delete posts
	const deletePostFilterData = (postId) => {
		const filteredPosts = allPosts.filter((post) => post._id !== postId);
		setAllPosts(filteredPosts);
	};

	const [postData, setPostData] = useState({});
	const [getSavedPostData, setGetSavedPostData] = useState("");

	const handleTabChange = (tab) => {
		trackCommunityAction("TabChange", { fromTab: activeTab, toTab: tab });
		setActiveTab(tab);
		if (tab === "settings") {
			setShowSettings(true);
		} else {
			setShowSettings(false);
		}
	};

	const [filterType, setFilterType] = useState("all");
	const [showFilterDropdown, setShowFilterDropdown] = useState(false);

	const getFilteredPosts = useMemo(() => {
		console.log('Filtering posts, current filter type:', filterType);
		console.log('All posts:', allPosts);
		console.log('Admin posts:', adminPosts);
		
		switch (filterType) {
			case "admin":
				return adminPosts;
			case "members":
				return allPosts.filter(
					(post) => post.user?._id !== community?.adminId?._id
				);
			default:
				return allPosts;
		}
	}, [allPosts, filterType, community]);

	const getRandomLightColor = () => {
		const r = Math.floor(Math.random() * 156 + 100); // Red value between 100-255
		const g = Math.floor(Math.random() * 156 + 100); // Green value between 100-255
		const b = Math.floor(Math.random() * 156 + 100); // Blue value between 100-255
		return `rgb(${r}, ${g}, ${b})`;
	};

	const formatDate = (dateString) => {
		const options = {
			year: "numeric",
			month: "long",
			day: "numeric",
			// hour: "2-digit",
			// minute: "2-digit",
			// hour12: true,
		};

		const date = new Date(dateString);
		return date.toLocaleDateString("en-IN", options);
	};

	const renderTabContent = () => {
		// Add this helper function at the start of renderTabContent
		const isWebinarPast = (startTime) => {
			const webinarDate = new Date(startTime);
			const currentDate = new Date();
			return webinarDate < currentDate;
		};

		switch (activeTab) {
			case "home":
				return (
					<div className="home-section">
						<div className="home-section-left">
							{isMobileView && (
								<>
									<div className="mobile-quick-actions">
										<button 
											className="action-btn products-btn"
											onClick={() => {
												handleTabChange("products");
												window.scrollTo({ top: 0, behavior: "smooth" });
											}}
										>
											View Products
										</button>
										<button 
											className="action-btn events-btn"
											onClick={() => {
												handleTabChange("events");
												window.scrollTo({ top: 0, behavior: "smooth" });
											}}
										>
											View Events
										</button>
									</div>
									<div className="home-section-webinar-card">
										{webinars
											.filter(event => !isWebinarPast(event.startTime))
											.slice(-1)
											.map((event) => (
												<div
													key={event._id}
													className="event-card"
													style={{ backgroundColor: getRandomLightColor() }}
													onClick={(e) => {
														if (!isWebinarPast(event.startTime)) {
															navigate(
																`/webinar/join-webinar/${event?.userId?.userName}/${event._id}`
															);
														} else {
															e.preventDefault();
														}
													}}
												>
													<div className="event-info">
														<h3>{event.title}</h3>

														<div className="event-meta">
															<div className="leftTime">
																<span>
																	<IoCalendarOutline size={20} />
																</span>{" "}
																&nbsp;&nbsp;
																<span>{formatDate(event.startTime)}</span>
																<span className="separator">|</span> &nbsp;&nbsp;
																<span>{event.duration} mins</span> &nbsp;&nbsp;
															</div>
															<div className="leftRight">
																{event?.price > 0 ? (
																	<div className="price-tag">
																		{event?.discount > 0 && (
																			<span className="original-price">
																				₹{event?.price}
																			</span>
																		)}
																		<span className="new-price">
																			₹
																			{(
																			event?.price *
																			(1 - event?.discount / 100)
																			).toFixed(0)}
																		</span>
																	</div>
																) : (
																	<div className="price-tag">
																		<b>Free</b>
																	</div>
																)}
															</div>
														</div>
													</div>
												</div>
											))}
									</div>
								</>
							)}

							{community?.whatsapp_group_link && showWhatsAppBanner && (
								<WhatsAppBanner
									onClick={() => setShowWhatsAppPopup(true)}
									onClose={() => setShowWhatsAppBanner(false)}
								/>
							)}
							<div className="create-post">
								<img
									src={loggedInUser?.profilePicture || avatar4}
									alt="Community"
								/>
								<input
									type="text"
									placeholder="Share your thoughts with the community..."
									onClick={() => {
										trackCommunityAction("CreatePost");
										setPopupOpen(true);
									}}
								/>
								<button
									className="filter-button"
									onClick={() => {
										trackCommunityAction("ToggleFilter", { currentState: !showFilterDropdown });
										setShowFilterDropdown(!showFilterDropdown);
									}}
								>
									<IoFilter />
								</button>
								{showFilterDropdown && (
									<div className="filter-dropdown">
										<div
											className="filter-option"
											onClick={() => {
												setFilterType("all");
												setShowFilterDropdown(false);
											}}
										>
											All Posts
										</div>
										<div
											className="filter-option"
											onClick={() => {
												setFilterType("admin");
												setShowFilterDropdown(false);
											}}
										>
											Admin Posts
										</div>
										<div
											className="filter-option"
											onClick={() => {
												setFilterType("members");
												setShowFilterDropdown(false);
											}}
										>
											Member Posts
										</div>
									</div>
								)}
							</div>
							<div className="posts-container">
								<InfiniteScroll
									className="m-0 p-0"
									dataLength={getFilteredPosts.length}
									next={fetchMorePosts}
									hasMore={hasMore}
									loader={<SkeletonLoader />}
								>
									{getFilteredPosts?.map(
										({
											description,
											user,
											video,
											image,
											images,
											documentUrl,
											documentName,
											createdAt,
											likes,
											_id,
											resharedPostId,
											pollOptions,
											allow_multiple_answers,
											resharedPost,
										}) => {
											console.log('Rendering post:', {
												_id,
												resharedPostId,
												resharedPost,
												user: user?._id
											});
											if (!user) {
												console.log('Skipping post due to missing user:', _id);
												return null;
											}

											const {
												firstName,
												lastName,
												location,
												designation,
												profilePicture,
												_id: userId,
												startUp,
												investor,
												oneLinkId,
												isSubscribed,
												isTopVoice,
												userName,
												bio,
												linkedin,
												experience,
												numberOfConnections,
												numberOfUserPosts,
												readinessUpdate,
												tractionUpdate,
											} = user;

											return (
												<FeedPostCard
													key={_id}
													userId={userId}
													postId={_id}
													designation={designation}
													startUpCompanyName={startUp}
													investorCompanyName={investor}
													profilePicture={profilePicture || avatar4}
													description={description}
													firstName={firstName}
													lastName={lastName}
													oneLinkId={oneLinkId}
													pollOptions={pollOptions}
													allow_multiple_answers={allow_multiple_answers}
													handlePollVote={handlePollVote}
													video={video}
													image={image}
													images={images}
													location={location}
													documentName={documentName}
													documentUrl={documentUrl}
													createdAt={createdAt}
													likes={likes}
													resharedPostId={resharedPostId}
													resharedPost={resharedPost}
													fetchAllPosts={fetchMorePosts}
													response={getSavedPostData}
													repostWithToughts={(resharedPostId) => {
														setRepostingPostId(resharedPostId);
														setPopupOpen(true);
													}}
													repostInstantly={repostInstantly}
													repostLoading={repostLoading}
													deletePostFilterData={deletePostFilterData}
													setPostData={setPostData}
													isSubscribed={isSubscribed}
													isTopVoice={isTopVoice}
													userName={userName}
													bio={bio}
													linkedin={linkedin}
													experience={experience}
													numberOfConnections={numberOfConnections}
													numberOfUserPosts={numberOfUserPosts}
													readinessUpdate={readinessUpdate}
													tractionUpdate={tractionUpdate}
													communityId={community._id}
												/>
											);
										}
									)}
								</InfiniteScroll>
							</div>
						</div>
						<div className="home-section-right">
							{/* Product card */}
							<div className="sidebar-card">
								<h2 className="sidebar-card-title">Top Products</h2>
								<div className="sidebar-card-content">
									{community?.products?.map((product) => (
										<div
											className="product-card"
											onClick={() => {
												handleTabChange("products");
												// Scroll to top after tab change
												window.scrollTo({ top: 0, behavior: "smooth" });
											}}
										>
											<div className="product-image">
												<img src={product.image} alt={product.name} />
												<span
													className={`badge ${
														product.is_free ? "free" : "paid"
													}`}
												>
													{product.is_free ? "Free" : `₹${product.amount}`}
												</span>
											</div>
											<div className="product-content">
												<h3 className="line-clamp-1">{product.name}</h3>
												<p className="line-clamp-3"><div dangerouslySetInnerHTML={{ __html: product.description }} /></p>
												{/* <button
													className="access-btn"
													onClick={() =>
														isPurchased ? onAccess(product) : onBuy(product)
													}
												>
													{isPurchased
														? "Access Resource"
														: product.is_free
														? "Buy for Free"
														: `Buy ₹${product.amount}`}
												</button> */}
											</div>
										</div>
									))}
								</div>
							</div>

							{/* Events card */}
							<div className="sidebar-card">
								<h2 className="sidebar-card-title">Upcoming Events</h2>
								<div className="sidebar-card-content">
									{webinars
										.filter(event => !isWebinarPast(event.startTime))
										.map((event) => (
											<div
												key={event._id}
												className="event-card"
												style={{ 
													backgroundColor: getRandomLightColor(),
													cursor: isWebinarPast(event.startTime) ? 'not-allowed' : 'pointer'
												}}
												onClick={(e) => {
													if (!isWebinarPast(event.startTime)) {
														handleTabChange("events");
														window.scrollTo({ top: 0, behavior: "smooth" });
													} else {
														e.preventDefault();
													}
												}}
											>
												<div className="event-info">
													<h3>{event.title}</h3>

													<div className="event-meta">
														<div className="leftTime">
															<span>
																<IoCalendarOutline size={20} />
															</span>{" "}
															&nbsp;&nbsp;
															<span>{formatDate(event.startTime)}</span>
															<span className="separator">|</span> &nbsp;&nbsp;
															<span>{event.duration} mins</span> &nbsp;&nbsp;
														</div>
														<div className="leftRight">
															{event?.price > 0 ? (
																<div className="price-tag">
																	{event?.discount > 0 && (
																		<span className="original-price">
																			₹{event?.price}
																		</span>
																	)}
																	<span className="new-price">
																	₹
																	{(
																		event?.price *
																		(1 - event?.discount / 100)
																	).toFixed(0)}
																	</span>
																</div>
															) : (
																<div className="price-tag">
																	<b>Free</b>
																</div>
															)}
														</div>
													</div>
												</div>
											</div>
										))}
									{webinars.filter(event => !isWebinarPast(event.startTime)).length === 0 && (
										<div className="no-events">
											No upcoming events at this time
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				);
			case "settings":
				return <UpdateCommunityForm community={community} setIsUpdated={setIsUpdated} isUpdated={isUpdated}/>;
			case "about":
				return <About community={community} />;
			case "events":
				return <Webinars communityId={community._id} />;
			case "people":
				return <PeopleTab community={community} />;
			case "products":
				return <Products community={community} />;
			default:
				return <div>Content coming soon...</div>;
		}
	};

	const handlePostCreated = (newPost) => {
		setAllPosts((prevPosts) => [newPost, ...prevPosts]);
		setPopupOpen(false);
		toast.success("Post created successfully!");
	};

	// Function to handle WhatsApp group join request
	const handleJoinWhatsAppGroup = async (phoneNumber) => {
		try {
			trackCommunityAction("JoinWhatsApp", { communityId });
			const token = localStorage.getItem("accessToken");
			const emailData = {
				name: loggedInUser.firstName + " " + loggedInUser.lastName,
				email: loggedInUser.email,
				phoneNumber: loggedInUser.phoneNumber,
				requestedNumber: phoneNumber,
				adminEmail: community?.adminId?.email,
			};

			const response = await axios.post(
				`${environment.baseUrl}/communities/sendJoinRequest`,
				emailData,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.status === 200) {
				toast.success("Join request sent successfully!");
				// Open WhatsApp link
				window.open(community.whatsapp_group_link, "_blank");
				// Small delay before closing popup and banner
				await new Promise((resolve) => setTimeout(resolve, 1500));
				setShowWhatsAppPopup(false);
				setShowWhatsAppBanner(false);
			}
		} catch (error) {
			console.error("Error sending join request:", error);
			toast.error("Failed to send join request. Please try again.");
			throw error; // Propagate error to maintain loading state in popup
		}
	};

	const handleOpenSocialShare = (communityId) => {
		trackCommunityAction("ShareCommunity", { communityId });
		const currentHost = window.location.origin;
		setCommunityUrl(`${currentHost}/community/${communityId}`);
		setSharePopupOpen(true);
	};

	// Add this function to handle email preference toggle
	const handleEmailPreferenceToggle = async () => {
		try {
			trackCommunityAction("ToggleEmailNotifications", { newState: !receiveEmails });
			const token = localStorage.getItem("accessToken");
			await toggleRecieveEmail(community._id);
			setReceiveEmails(!receiveEmails);
			toast.success("Email preferences updated successfully!");
		} catch (error) {
			console.error("Error updating email preferences:", error);
			toast.error("Failed to update email preferences");
		}
	};

	// Add this function to handle leaving community
	const handleLeaveCommunity = async () => {
		if (isLeaving) return;
		setIsLeaving(true);
		try {
			trackCommunityAction("LeaveCommunity", { reason: leaveReason });
			const token = localStorage.getItem("accessToken");
			await axios.post(
				`${environment.baseUrl}/communities/leaveCommunity/${community._id}`,
				{ reason: leaveReason },
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			);
			toast.success("Successfully left the community");
			navigate("/ExploreCommunities");
		} catch (error) {
			console.error("Error leaving community:", error);
			toast.error("Failed to leave the community");
		} finally {
			setIsLeaving(false);
			setLeaveDialogOpen(false);
		}
	};

	const repostInstantly = (resharedPostId) => {
		console.log('Starting instant repost with ID:', resharedPostId);
		setRepostLoading({ ...repostLoading, instant: true });
		postUserPost({ 
			resharedPostId,
			postType: "community",
			communityId: community._id 
		})
			.then((response) => {
				console.log('Repost successful, response:', response);
				return fetchMorePosts();
			})
			.catch((err) => {
				console.error('Error in repost:', err);
				console.log(err);
			})
			.finally(() => {
				console.log('Repost operation completed');
				setRepostLoading({ ...repostLoading, instant: false });
			});
	};

	return (
		<div className="community-page" data-bs-theme={theme}>
			<Toaster
				position="top-right"
				toastOptions={{
					duration: 5000,
					style: {
						background: "#363636",
						color: "#fff",
					},
				}}
			/>
			{!isLoading && community && (
				<div className="community-header">
					<div className="community-info">
						<div className="info-wrapper">
							{isMobileView &&
								(!isSidebarOpen ? (
									<MdMenu
										size={25}
										style={{
											color: "var(--d-l-grey)",
										}}
										onClick={() => setIsSidebarOpen((prevState) => !prevState)}
									/>
								) : (
									<MdMenuOpen
										size={25}
										style={{
											color: "var(--d-l-grey)",
										}}
										onClick={() => setIsSidebarOpen((prevState) => !prevState)}
									/>
								))}

							<img src={community?.image} alt={community?.name} />
							<div className="info-text">
								<div className="title-with-share">
									<h1>{community?.name}</h1>
									<FaShareAlt
										className="share-icon"
										onClick={() => handleOpenSocialShare(community?._id)}
									/>
								</div>
								<p>{community?.description}</p>
								<div className="stats">
									<span>{community?.members?.length} members</span>
									<span>{allPosts.length} posts</span>
								</div>
							</div>
						</div>
						{!isMobileView && (
							<nav className="horizontal-menu">
								<button
									className={activeTab === "home" ? "active" : ""}
									onClick={() => handleTabChange("home")}
								>
									Home
								</button>
								<button
									className={activeTab === "products" ? "active" : ""}
									onClick={() => handleTabChange("products")}
									data-tab="products"
								>
									Products & Services
								</button>
								<button
									className={activeTab === "people" ? "active" : ""}
									onClick={() => handleTabChange("people")}
								>
									People
								</button>
								<button
									className={activeTab === "about" ? "active" : ""}
									onClick={() => handleTabChange("about")}
								>
									About
								</button>
								{isAdmin && (
									<button
										className={activeTab === "settings" ? "active" : ""}
										onClick={() => handleTabChange("settings")}
									>
										Settings
									</button>
								)}
							</nav>
						)}
						<div className="right-elements">
							{!isMobileView && !isAdmin && (
								<div className="settings-dropdown-container">
									<button
										className="settings-button"
										onClick={() => setShowSettingsDropdown(!showSettingsDropdown)}
									>
										<IoSettingsOutline size={20} />
									</button>
									{showSettingsDropdown && (
										<div className="settings-dropdown">
											<div className="settings-item">
												<label className="email-toggle">
													<input
														type="checkbox"
														checked={receiveEmails}
														onChange={handleEmailPreferenceToggle}
													/>
													Receive Community Emails
												</label>
											</div>
											<div 
												className="settings-item leave-community"
												onClick={() => {
													setLeaveDialogOpen(true);
													setShowSettingsDropdown(false);
												}}
											>
												Leave Community
											</div>
										</div>
									)}
								</div>
							)}
							{!isMobileView && <OnboardingSwitch />}
							{!isMobileView && (
								<Link to="/manage-account" className="profile-link">
									<img
										src={loggedInUser?.profilePicture || avatar4}
										alt="Profile"
										className="profile-pic"
									/>
								</Link>
							)}
						</div>
					</div>
				</div>
			)}

			<div className="community-content">
				<div className="main-content">
					{/* {isAdmin && (
						<CompletionBanner 
							community={community}
							onShareClick={() => handleOpenSocialShare(community?._id)}
							adminPosts={adminPosts}
						/>
					)} */}
					{renderTabContent()}

					{popupOpen && (
						<CreatePostPopUp
							setPopupOpen={setPopupOpen}
							popupOpen={popupOpen}
							communityId={community?._id}
							appendDataToAllPosts={handlePostCreated}
							respostingPostId={respostingPostId}
							setRepostingPostId={setRepostingPostId}
							postType="community"
						/>
					)}
					{!isMobileView && (
						<Link to="/home" className="desktop-logo-link">
							<img
								src={theme === "dark" ? WhiteLogo : DarkLogo}
								alt="The Capital Hub"
							/>
						</Link>
					)}
				</div>
			</div>
			{showWhatsAppPopup && (
				<JoinWhatsAppGroupPopup
					onClose={() => setShowWhatsAppPopup(false)}
					onJoin={handleJoinWhatsAppGroup}
				/>
			)}
			{isMobileView && isSidebarOpen && (
				<div className="mobile-sidebar">
					<div className="sidebar-header">
						<Link to="/manage-account" className="profile-section">
							<img
								src={loggedInUser?.profilePicture || avatar4}
								alt="Profile"
								className="profile-pic"
							/>
							<div className="profile-info">
								<h3>
									{loggedInUser?.firstName} {loggedInUser?.lastName}
								</h3>
								<p>{loggedInUser?.designation}</p>
							</div>
						</Link>
					</div>

					<div className="sidebar-onboarding">
						<OnboardingSwitch />
					</div>

					<nav className="sidebar-menu">
						<button
							className={activeTab === "home" ? "active" : ""}
							onClick={() => {
								handleTabChange("home");
								setIsSidebarOpen(false);
							}}
						>
							Home
						</button>
						<button
							className={activeTab === "products" ? "active" : ""}
							onClick={() => {
								handleTabChange("products");
								setIsSidebarOpen(false);
							}}
						>
							Products
						</button>
						<button
							className={activeTab === "people" ? "active" : ""}
							onClick={() => {
								handleTabChange("people");
								setIsSidebarOpen(false);
							}}
						>
							People
						</button>
						<button
							className={activeTab === "about" ? "active" : ""}
							onClick={() => {
								handleTabChange("about");
								setIsSidebarOpen(false);
							}}
						>
							About
						</button>
						{isAdmin && (
							<button
								className={activeTab === "settings" ? "active" : ""}
								onClick={() => {
									handleTabChange("settings");
									setIsSidebarOpen(false);
								}}
							>
								Settings
							</button>
						)}
						<Link to="/home" className="logo-link">
							<img
								src={theme === "dark" ? WhiteLogo : DarkLogo}
								alt="The Capital Hub"
							/>
						</Link>
					</nav>
				</div>
			)}
			<SharePopup
				url={communityUrl}
				isOpen={sharePopupOpen}
				setIsOpen={setSharePopupOpen}
			/>
			{/* Add Leave Community Dialog */}
			<Dialog open={leaveDialogOpen} onClose={() => setLeaveDialogOpen(false)}>
				<DialogTitle>Leave Community</DialogTitle>
				<DialogContent>
					<p>Are you sure you want to leave this community?</p>
					<TextField
						fullWidth
						multiline
						rows={4}
						label="Reason for leaving"
						value={leaveReason}
						onChange={(e) => setLeaveReason(e.target.value)}
						margin="normal"
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setLeaveDialogOpen(false)}>Cancel</Button>
					<Button 
						onClick={handleLeaveCommunity} 
						color="error"
						disabled={isLeaving}
					>
						{isLeaving ? 'Leaving...' : 'Leave'}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default Community;
